import * as React from "react";
import DatePickerWithIcon from "../DatePickerWithIcon/DatePickerWithIcon";
import TimePicker from "../TimePicker/TimePicker";
import "./dateTimePicker.scss";
import DateUtils from "../../../../utils/DateUtils";
import {isNullOrUndefined} from "util";
import moment = require("moment");

interface IProps {
	/**
	 * Max available date.
	 */
	maxDate?: moment.Moment;
	/**
	 * Min available date.
	 */
	minDate?: moment.Moment;
	/**
	 * Start time in 'HH:mm' format.
	 */
	startTime?: string;
	/**
	 * End time in 'HH:mm' format.
	 */
	endTime?: string;
	/**
	 * Initial date time for date time picker.
	 */
	initialDateTime?: moment.Moment;
	/**
	 * Ond ate time change callback.
	 * @param {moment.Moment} dateTime
	 */
	onDateTimeChange?: (dateTime: moment.Moment) => void;
	/**
	 * Time picker disable flag.
	 */
	timeDisabled?: boolean;
	/**
	 * Date picker disable flag.
	 */
	dateDisabled?: boolean;
	/**
	 * Disabled date times
	 */
	disabledDateTimes?: moment.Moment[]
	/**
	 * Excluded dates form date picker
	 */
	excludeDates?: moment.Moment[]
}

export default class DateTimePicker extends React.Component<IProps, {}> {

	public static defaultProps: Partial<IProps> = {
		maxDate: moment().add(10, "year"),
		minDate: moment()
	};

	constructor(props: IProps) {
		super(props);
		this.onDateChange = this.onDateChange.bind(this);
		this.onTimeChange = this.onTimeChange.bind(this);
		this.initialDateEmptyOrInvalid = this.initialDateEmptyOrInvalid.bind(this);
	}

	render() {
		return (
			<div className={"m-date-time-picker"}>
				<DatePickerWithIcon onDateChange={this.onDateChange}
									minDate={this.props.minDate}
									maxDate={this.props.maxDate}
									initialDate={this.props.initialDateTime}
									disabled={this.props.dateDisabled}
									placeholder={"Date"}
									excludeDates={this.props.excludeDates}/>
				<TimePicker initialDateTime={this.props.initialDateTime}
							startTime={this.props.startTime}
							endTime={this.props.endTime}
							onTimeChange={this.onTimeChange}
							disabled={this.initialDateEmptyOrInvalid()}
							placeholder={"Time"}
							disabledDateTimes={this.props.disabledDateTimes}/>
			</div>
		);
	}

	/**
	 * Indicates if date is not set or is invalid.
	 * @return {boolean}
	 */
	initialDateEmptyOrInvalid() {
		return this.props.timeDisabled || !this.props.initialDateTime || !this.props.initialDateTime.isValid();
	}

	/**
	 * Handle date change.
	 * @param {moment.Moment} date
	 */
	onDateChange(date: moment.Moment) {
		const futureDate = DateUtils.firstInFutureByInterval(date, 15);
		for (let t = 360; t <= 22 * 60; t += 15) {
			const timeWithInterval = moment(futureDate).startOf("day").add(t, "m");
			if (timeWithInterval.isSameOrAfter(futureDate) &&
				(isNullOrUndefined(this.props.disabledDateTimes) ||
					!this.props.disabledDateTimes.map(item => item.isSame(timeWithInterval)).some(disable => disable))) {
				return this.props.onDateTimeChange(timeWithInterval);
			}
		}
		return this.props.onDateTimeChange(futureDate.add(6, "h"));
	}

	/**
	 * Handle time change and merge time with reminder date.
	 * @param {moment.Moment} time
	 */
	onTimeChange(time: moment.Moment) {
		this.props.onDateTimeChange(moment(this.props.initialDateTime).hours(time.hours()).minutes(time.minutes()));
	}
}
